import { motion } from "framer-motion"

const IconClose = ({ className, size = 32, fill = "currentColor", ...animations }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <motion.path
      {...animations}
      d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
      fill={fill}
      stoke="none"
      fillRule="evenodd"
    />
  </svg>
)

export default IconClose
